import useTranslation from 'next-translate/useTranslation';

//Components
import ItemWrapper from '@/components/pages/reports/components/Items/ItemWrapper';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';
import type { DashboardType } from '@/types/dashboardType';
import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';

type DashboardItemProps = {
    socialProfiles: SocialProfileType[];
    spGroups?: SpGroupType[];
    item: DashboardType;
    size: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
    spClassName?: string;
};

const DashboardItem = ({
    socialProfiles,
    spGroups,
    item,
    size = 'sm',
    className,
    spClassName
}: DashboardItemProps) => {
    const { t } = useTranslation('reports');

    return (
        <ItemWrapper
            spList={spGroups?.length > 0 ? [...spGroups, ...socialProfiles] : socialProfiles}
            mainContent={item?.name}
            subContent={
                (socialProfiles?.length > 0
                    ? t('create.social_profile', {
                          count: socialProfiles?.length
                      })
                    : '') +
                (spGroups?.length > 0
                    ? (socialProfiles?.length > 0 ? ', ' : '') +
                      t('create.group', {
                          count: spGroups?.length
                      })
                    : '')
            }
            size={size}
            className={className}
            spClassName={spClassName}
        />
    );
};

export default DashboardItem;
